import { getQueryStateId } from '$api/query-state-api';
import { QueryState } from '$scripts/query-state';
import { tempestRedirectUrl } from '$scripts/urls/list';
import { AUTH_FAILED_REASON } from '$shared/types/auth-failed-reasons';
import { SocialProvider } from '$shared/types/social-provider';
import { AuthFailedOutcome } from '$traits/outcomes';
import { getLoggers } from '$shared/loggers';

export async function createTokenExchangeErrorOutcome(
  client_id: string,
  queryState: QueryState,
  token: string,
  socialProvider: SocialProvider
): Promise<AuthFailedOutcome> {
  const { logInfo } = getLoggers();
  
  logInfo('Packing query state');
  const { id: queryStateId } = await getQueryStateId(client_id, queryState);
  logInfo('Query state packed');

  const tempestOriginUrl = tempestRedirectUrl({
    state: JSON.stringify({
      queryStateId,
      client_id,
      clientId: client_id,
    }),
  })();

  const fallbackUrl = `${tempestOriginUrl}#/social/${socialProvider}/${token}/example`;
  await logInfo(`AuthFailed with Fallback URL -> AuthFailedOutcome`);
  
  return new AuthFailedOutcome({
    reason: AUTH_FAILED_REASON.rideError,
    fallbackUrl,
  });
} 
